/**
 * BR 管理员内部备注 — 附件限制（对齐 Post Sourcing 上传体验）
 */
export const BR_ADMIN_NOTE_MAX_ATTACHMENTS = 5;
export const BR_ADMIN_NOTE_MAX_FILE_SIZE_MB = 10;
export const BR_ADMIN_NOTE_MAX_FILE_SIZE_BYTES = BR_ADMIN_NOTE_MAX_FILE_SIZE_MB * 1024 * 1024;

/** 图片 + 常见办公文档（与 Post Sourcing 同类） */
export const BR_ADMIN_NOTE_ACCEPT_EXT = [
  'png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg',
  'xls', 'xlsx', 'doc', 'docx', 'txt', 'pdf',
];

/** 给用户看的格式列表（大写） */
export const BR_ADMIN_NOTE_ACCEPT_LABEL = BR_ADMIN_NOTE_ACCEPT_EXT
  .map((ext) => ext.toUpperCase())
  .join(', ');

export const BR_ADMIN_NOTE_ACCEPT_ATTR = BR_ADMIN_NOTE_ACCEPT_EXT
  .map((ext) => `.${ext}`)
  .join(',');

export function getBrAdminNoteFileExt(fileName) {
  const name = String(fileName || '');
  const idx = name.lastIndexOf('.');
  if (idx < 0) return '';
  return name.slice(idx + 1).toLowerCase();
}

/**
 * @returns {'ok'|'type'|'size'|'empty'}
 */
export function validateBrAdminNoteFile(file) {
  if (!file) return 'empty';
  const ext = getBrAdminNoteFileExt(file.name);
  if (!BR_ADMIN_NOTE_ACCEPT_EXT.includes(ext)) return 'type';
  if (Number(file.size) > BR_ADMIN_NOTE_MAX_FILE_SIZE_BYTES) return 'size';
  return 'ok';
}
